import { cmsRoutes } from "./routes/CMSRoutes";
import { rootRoutes } from "./routes/RootRoutes";
import { adminRoutes } from "./routes/AdminRoutes";
import { organizeRoutes } from "./routes/OrganizeRoutes";
import { playRoutes } from "./routes/PlayRoutes";
import { shopRoutes } from "./routes/ShopRoutes";
import { accountRoutes } from "./routes/AccountRoutes";
import { rankingsRoutes } from "./routes/RankingsRoutes";
import { subscriptionRoutes } from "./routes/SubscriptionRoutes";
import { appRoutes } from "./routes/AppRoutes";
import { organizationRoutes } from "./routes/OrganizationRoutes";
import { legacyRoutes } from "./routes/LegacyRoutes";

export function isRouteMatch(routeMatch) {
  var pathSplit = window.location.pathname.substring(1).split("/");
  var routeSplit = routeMatch.substring(1).split("/");
  var obj = {
    _match: pathSplit.length === routeSplit.length
  };
  for (var i = 0; i < pathSplit.length || i < routeSplit.length; i++) {
    if (pathSplit[i] && routeSplit[i]) {
      if (routeSplit[i][0] && routeSplit[i][0] === ":") {
        obj[routeSplit[i].substring(1)] = pathSplit[i];
      } else if (pathSplit[i].toLowerCase() === routeSplit[i].toLowerCase()) {
      } else {
        obj._match = false;
        break;
      }
      obj._match = true;
    } else {
      obj._match = false;
      break;
    }
  }
  return obj;
}

const Routes = (
  authContext,
  itemsMiddle,
  setItemsMiddle,
  eventObject,
  setEventObject
) => {
  let _routes = [
    ...appRoutes(
      authContext,
      itemsMiddle,
      setItemsMiddle,
      eventObject,
      setEventObject
    ),
    ...cmsRoutes(authContext, itemsMiddle, setItemsMiddle),
    ...adminRoutes(authContext, itemsMiddle, setItemsMiddle),
    ...organizeRoutes(authContext, itemsMiddle, setItemsMiddle),
    ...playRoutes(authContext, itemsMiddle, setItemsMiddle),
    ...shopRoutes(authContext, itemsMiddle, setItemsMiddle),
    ...accountRoutes(authContext, itemsMiddle, setItemsMiddle),
    ...organizationRoutes(
      authContext,
      itemsMiddle,
      setItemsMiddle,
      eventObject,
      setEventObject
    ),
    ...rankingsRoutes(
      authContext,
      itemsMiddle,
      setItemsMiddle,
      eventObject,
      setEventObject
    ),
    ...subscriptionRoutes(
      authContext,
      itemsMiddle,
      setItemsMiddle,
      eventObject,
      setEventObject
    ),
    ...legacyRoutes(),
    ...rootRoutes(
      authContext,
      itemsMiddle,
      setItemsMiddle,
      eventObject,
      setEventObject
    )
  ];
  return _routes;
};

export default Routes;
